import React, { Fragment, useState, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import matchSorter from 'match-sorter';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import {
    setInitiative,
} from 'actions/initiative';
import { TIGHT_FIT_PARAM, TABLE_NAME_FIELD_WIDTH, TABLE_NAME_FIELD_TIGHT_FIT_WIDTH } from 'constants/System';

const InitiativeTable = () => {
    const dispatch = useDispatch();
    const width = useSelector(state => state.settings.width);
    const initiativeList = useSelector(state => state.initiatives.initiativeList);
    const selectedInitiative = useSelector(state => state.initiatives.selectedInitiative);
    const [selected, setSelected] = useState(0);

    const defaultWidth = width > TIGHT_FIT_PARAM ? TABLE_NAME_FIELD_WIDTH : TABLE_NAME_FIELD_TIGHT_FIT_WIDTH;

    useLayoutEffect(() => {
        const selected = initiativeList.findIndex(entry => entry?.id === selectedInitiative?.id) || 0;
        setSelected(selected);
    }, []);

    const styledSummaryColumn = (value) => {
        return <Fragment>
            <span className="d-inline-block text-black">
                <div className="font-weight-bold">{value}</div>
            </span>
        </Fragment>;
    };
    const nameColumn = {
        Header: 'Name',
        id: 'name',
        accessor: d => d?.name,
        filterMethod: (filter, rows) =>
            matchSorter(rows, filter.value, { keys: ['name'] }),
        Cell: ({ value }) => {
            return styledSummaryColumn(value);
        },
        filterAll: true,
        width: defaultWidth,
    };
    const descColumn = {
        Header: 'Description',
        id: 'desc',
        accessor: d => d?.description,
        filterMethod: (filter, rows) =>
            matchSorter(rows, filter.value, { keys: ['desc'] }),
        filterAll: true,
    };

    const columnsList = new Array();
    columnsList.push(nameColumn);
    if (width > TIGHT_FIT_PARAM) {
        columnsList.push(descColumn);
    }
    return (
        <div style={{ marginLeft: '10px', marginRight: '10px' }}>
            <ReactTable
                data={initiativeList}
                filterable
                defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]) === filter.value}
                columns={[
                    {
                        columns: columnsList
                    }
                ]}
                defaultPageSize={10}
                getTrProps={(state, rowInfo) => {
                    if (rowInfo && rowInfo.row) {
                        return {
                            onClick: () => {
                                // console.log(JSON.stringify(rowInfo?.index));
                                dispatch(setInitiative(rowInfo?.original?.id));
                                setSelected(rowInfo.index);
                            },
                            style: {
                                background: rowInfo.index === selected ? '#cfd8dc' : 'white',
                                color: rowInfo.index === selected ? 'black' : 'black'
                            }
                        };
                    } else {
                        return {};
                    }
                }}
            />
        </div>
    );
};

export default InitiativeTable;


// WEBPACK FOOTER //
// ./components/Agile/initiative/initiativeTable/index.js